import React, { useState, useEffect } from "react";
import { Modal, Button, Typography } from "antd";
import { ExclamationCircleOutlined, LogoutOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { logout } from "../store/reducers/authSlice";
import { setAuthToken } from "../utils/authentication";
import { notify } from "../utils/notification";

const { Text, Paragraph } = Typography;

interface SharePointValidationModalProps {
  visible: boolean;
  onSignOut: () => void;
}

const SharePointValidationModal: React.FC<SharePointValidationModalProps> = ({
  visible,
  onSignOut,
}) => {
  const [countdown, setCountdown] = useState(10);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!visible) {
      setCountdown(10);
      return;
    }

    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          // Auto sign out when countdown reaches 0
          handleSignOut();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [visible]);

  const handleSignOut = () => {
    try {
      // Clear authentication token
      setAuthToken("");

      // Dispatch logout action to clear Redux store
      dispatch(logout());

      // Call the onSignOut callback
      onSignOut();

      notify.success({
        message: "Signed Out",
        description: "You have been successfully signed out.",
      });
    } catch (error) {
      notify.error({
        message: "Sign Out Failed",
        description: "An error occurred while signing out. Please try again.",
      });
    }
  };

  return (
    <Modal
      title={
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <ExclamationCircleOutlined style={{ color: "#faad14" }} />
          <span>SharePoint Configuration Issue</span>
        </div>
      }
      open={visible}
      footer={null}
      closable={false}
      maskClosable={false}
      width={500}
      centered
    >
      <div style={{ textAlign: "center", padding: "20px 0" }}>
        <Paragraph>
          Your SharePoint configuration is invalid or has expired. Please
          contact your Archivist
        </Paragraph>

        <div style={{ margin: "20px 0" }}>
          <Text strong style={{ fontSize: "16px", color: "#fa541c" }}>
            Auto sign-out in: {countdown} seconds
          </Text>
        </div>

        <Button
          type="primary"
          danger
          size="large"
          icon={<LogoutOutlined />}
          onClick={handleSignOut}
          style={{ minWidth: "120px" }}
        >
          Sign Out Now
        </Button>
      </div>
    </Modal>
  );
};

export default SharePointValidationModal;
